import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {catchError, map, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {CachingInterceptor} from '../../caching/services/caching-interceptor';
import {Country} from '../model/country';
import {quotesErrorSelector} from './abstract-quote.service';

const CountriesResources = {
    countries: '/V1/directory/countries',
};

@Injectable()
export class CountriesService {
    constructor(private http: HttpClient) {
    }

    getCountries(): Observable<Country[]> {
        return this.http.get<CountryEntity[]>(this.determineCountriesUrl(), {
            headers: CachingInterceptor.createCacheHeader()
        }).pipe(
            tap(response => console.log(response)),
            map(countries => countries.map(c => this.convertCountryEntity(c))),
            catchError(err => quotesErrorSelector(err))
        );
    }

    private convertCountryEntity(countryEntity: CountryEntity): Country {
        return {
            iso2Code: countryEntity.two_letter_abbreviation,
            name: countryEntity.full_name_locale,
            englishName: countryEntity.full_name_english
        };
    }

    private determineCountriesUrl() {
        return environment.rest_backend + CountriesResources.countries;
    }
}

class CountryEntity {
    two_letter_abbreviation: string;
    full_name_locale: string;
    full_name_english: string;
}
